import { DatePicker, Form } from 'antd';

import {
  fromOperationDateTime,
  OPERATION_DATETIME_UI_FORMAT,
  toOperationDateTime,
} from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/utils';

import type { Dayjs } from 'dayjs';

const { Item } = Form;

interface Props {
  name: string;
}

export const OperationDateField = ({ name }: Props) => (
  <Item
    name={name}
    label="Дата и время"
    required
    getValueProps={(value) => ({
      value: fromOperationDateTime(value) ?? undefined,
    })}
    getValueFromEvent={(value: Dayjs | null) => toOperationDateTime(value)}
    rules={[{ required: true, message: 'Пожалуйста, укажите дату и время' }]}
  >
    <DatePicker
      className="full-width"
      showTime
      format={OPERATION_DATETIME_UI_FORMAT}
    />
  </Item>
);
